module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<html>\n  <head>\n    <title><%- appName %></title>\n    <meta charset="utf-8" />\n    <meta name="viewport" content="width=device-width, initial-scale=1">\n    <link rel="preload" href="<%- fontPath %>" as="font">\n    <script src="https://code.jquery.com/jquery-1.12.1.min.js"></script>\n    <script>\n      function setExportConfig(config) { window.EXPORT_OPTIONS = config; }\n    </script>\n    <script src="<%- exportConfigPath %>"></script>\n    <script src="applab/applab-api.js"></script>\n    <script src="https://www.google.com/jsapi"></script>\n    <link rel="stylesheet" href="applab/applab.css">\n    <link rel="stylesheet" href="style.css">\n  </head>\n  <body>\n    <%- htmlBody %>\n  </body>\n</html>\n', __filename = "src/templates/export/project.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            __append("<html>\n  <head>\n    <title>");
            __line = 3;
            __append(appName);
            __append('</title>\n    <meta charset="utf-8" />\n    <meta name="viewport" content="width=device-width, initial-scale=1">\n    <link rel="preload" href="');
            __line = 6;
            __append(fontPath);
            __append('" as="font">\n    <script src="https://code.jquery.com/jquery-1.12.1.min.js"></script>\n    <script>\n      function setExportConfig(config) { window.EXPORT_OPTIONS = config; }\n    </script>\n    <script src="');
            __line = 11;
            __append(exportConfigPath);
            __append('"></script>\n    <script src="applab/applab-api.js"></script>\n    <script src="https://www.google.com/jsapi"></script>\n    <link rel="stylesheet" href="applab/applab.css">\n    <link rel="stylesheet" href="style.css">\n  </head>\n  <body>\n    ');
            __line = 18;
            __append(htmlBody);
            __append("\n  </body>\n</html>\n");
            __line = 21;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}